import React from 'react';
import { mergeSx } from '../../utils/sx/merge';
import { Box } from '../box';
import { PageLayoutProps } from './model';
export type { PageLayoutProps } from './model';

/**
 * PageLayout
 *
 * Component, which renders children inside styled container with default settings for page,
 * such as backgroundColor, minHeight etc.
 *
 * @param sx SxProps.
 */
export const PageLayout: React.FC<PageLayoutProps> = ({ children, sx }) => {
  return (
    <Box component="main" sx={mergeSx({ backgroundColor: 'background.paper', minHeight: '100vh' }, sx)}>
      {children}
    </Box>
  );
};
